module.exports = __webpack_public_path__ + "img/transpress-logo.0c9d91de.png";